var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgManageuserIcon = function SvgManageuserIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1497",
    "data-name": "Group 1497",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 107.589,
    height: 70.034,
    viewBox: "0 0 107.589 70.034",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2511",
    "data-name": "Rectangle 2511",
    width: 107.589,
    height: 70.034,
    fill: "#17445c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1497-2",
    "data-name": "Group 1497",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1017",
    "data-name": "Path 1017",
    d: "M137.3,86.917H70.385a6.365,6.365,0,0,1-6.358-6.358V70.333a.92.92,0,0,1,1.84,0V80.559a4.523,4.523,0,0,0,4.518,4.519H137.3a4.523,4.523,0,0,0,4.518-4.519V36.326a4.523,4.523,0,0,0-4.518-4.518H95.567a.92.92,0,0,1,0-1.84H137.3a6.365,6.365,0,0,1,6.358,6.358V80.559a6.365,6.365,0,0,1-6.358,6.358",
    transform: "translate(-36.071 -16.883)",
    fill: "#17445c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1018",
    "data-name": "Path 1018",
    d: "M214.289,53.184l-4.471,3.6h4.471v3.188h-14.45V56.784h8.912l-3.963-3.433V48.967l4.384,4.231,5.118-4.5ZM205.6,62.521a3.308,3.308,0,0,1,2.643-.839h6.041V64.87h-4.8c-1.049,0-1.112.021-1.51.21a1.366,1.366,0,0,0-.734,1.259c0,1.069.713,1.678,1.951,1.678h5.1V71.2h-9.5V68.016h1.2c-.189-.146-.336-.293-.482-.419a3.319,3.319,0,0,1-.944-2.475,3.365,3.365,0,0,1,1.049-2.6m-4.463,9.035a1.937,1.937,0,1,1,1.378-.567,1.945,1.945,0,0,1-1.378.567m-1.3,1.363H214.3v3.188h-14.45Zm11.871,9.756a2.174,2.174,0,1,1-2.161-2.056,2.114,2.114,0,0,1,2.161,2.056m-7.237-.839a3.843,3.843,0,0,0,.818,2.412c.084.084.231.231.42.4h-5.871v3.188H214.3V84.646H213.24a2.609,2.609,0,0,0,1.09-1.364,3.563,3.563,0,0,0,.273-1.4c0-2.58-2.2-4.572-5.1-4.572-2.852,0-5.034,1.971-5.034,4.53",
    transform: "translate(-112.222 -27.433)",
    fill: "#17445c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1019",
    "data-name": "Path 1019",
    d: "M209.278,52.786",
    transform: "translate(-117.901 -29.738)",
    fill: "#17445c"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_61",
    "data-name": "Line 61",
    x2: 64.765,
    transform: "translate(37.126 64.269)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2510",
    "data-name": "Rectangle 2510",
    width: 64.765,
    height: 2.912,
    transform: "translate(37.126 62.813)",
    fill: "#17445c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    "data-name": "Path 1020",
    d: "M61.059,30.994l-.045-.361-.232-1.113-.062-.239A14.02,14.02,0,0,0,57.5,23.364l-1.021-1-.214-.181a13.675,13.675,0,0,0-4.979-2.713l-.17-.051.152-.092a7.741,7.741,0,1,0-8.01,0l.151.091-.169.052a13.8,13.8,0,0,0-4.926,2.681l-1.054.929-.223.241a14,14,0,0,0-2.338,3.455l-.183-.2L33.37,25.5l-.313-.267a19.739,19.739,0,0,0-7.187-3.917l-.679-.2a.156.156,0,0,1-.036-.282l.606-.368a11.03,11.03,0,1,0-11.4-.01l.606.366a.156.156,0,0,1-.035.282l-.678.2a19.924,19.924,0,0,0-7.112,3.872l-.309.261L5.633,26.5l-.011.011-.327.355a20.208,20.208,0,0,0-4.7,8.6L.5,35.818l-.27,1.59-.067.53A20.653,20.653,0,0,0,0,40.547v.913a8.049,8.049,0,0,0,8.05,8.05H32.106a8.049,8.049,0,0,0,8.049-8.049v-.913c0-.462-.021-.935-.055-1.413H55.456a5.726,5.726,0,0,0,5.72-5.72v-.621a14.3,14.3,0,0,0-.117-1.8M41.047,12.7a6.192,6.192,0,0,1,6.2-6.188,6.128,6.128,0,0,1,.692.039A6.188,6.188,0,0,1,47.6,18.874h-.71A6.2,6.2,0,0,1,41.047,12.7M10.583,11.022a9.443,9.443,0,1,1,10,9.431H19.5a9.453,9.453,0,0,1-8.922-9.431M38.549,41.461a6.474,6.474,0,0,1-6.474,6.474H8.017a6.474,6.474,0,0,1-6.474-6.474v-.913A18.636,18.636,0,0,1,19.5,22.044h.056c.159.014.334.014.493.014s.333,0,.492-.014H20.6A18.476,18.476,0,0,1,34.01,28.483c.2.306.777.885,1.206,1.551A18.454,18.454,0,0,1,38.288,37.5c.056.414.187,1.379.2,1.6.038.477.063.958.063,1.444ZM59.6,33.414a4.17,4.17,0,0,1-4.165,4.165h-15.5l-.021-.16-.333-1.59-.092-.352a20.228,20.228,0,0,0-3.663-7.362A12.453,12.453,0,0,1,46.89,20.44c.126-.007.3,0,.723,0A12.442,12.442,0,0,1,59.6,32.793Z",
    fill: "#17445c"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgManageuserIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/manageuser-icon.8e53dd2676f2734a133cec60f7a4136b.svg";